import { forwardRef, memo } from 'react';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import PropTypes from 'prop-types';

import IconError from 'src/assets/icons/Error';
import IconWarning from 'src/assets/icons/Warning';
import Information from 'src/components/Information';

import { useStyles } from './useStyles';

export const ERROR_PANEL_TYPE = {
  warning: 'warning',
  error: 'error',
};

export const ErrorPanel = memo(
  forwardRef(({ className, classes, text, type, informationContent }, ref) => {
    const styles = useStyles({ classes });

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
      >
        {type === ERROR_PANEL_TYPE.error ? (
          <IconError className={styles.icon} />
        ) : (
          <IconWarning className={styles.icon} />
        )}

        <Typography
          className={styles.text}
          component="div"
        >
          {text}
        </Typography>

        {informationContent && (
          <Information
            className={styles.informationIcon}
            content={informationContent}
          />
        )}
      </div>
    );
  })
);

ErrorPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.oneOf(Object.values(ERROR_PANEL_TYPE)),
  informationContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

ErrorPanel.defaultProps = {
  className: null,
  classes: null,
  text: '',
  type: ERROR_PANEL_TYPE.warning,
  informationContent: null,
};
